import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { forYouItems, notForYouItems } from '../data/forWho';
export function ForWhoSection() {
  return <section aria-label="Per chi è il pacchetto" className="bg-brand-cream px-4 py-20 md:py-28" data-id="element-99" data-mp="2h66tb8cy65p5">
      <Reveal className="mx-auto grid max-w-content gap-5 md:grid-cols-2" data-id="element-100" data-mp="2c7nbnk5dzg2l">
        <article className="overflow-hidden rounded-[18px] bg-brand-alt shadow-sm" data-id="element-101" data-mp="2c5j50ug3s2ym">
          <h2 className="bg-brand-teal px-6 py-4 text-sm font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-102" data-mp="283p88x913j3q">
            È PER TE SE:
          </h2>
          <ul className="divide-y divide-brand-sand" data-id="element-103" data-mp="1y6szcqf7wuyn">
            {forYouItems.map(item => <li key={item} className="flex items-start gap-3 px-6 py-4" data-id="element-104" data-mp="1t9azrqn3bs3b">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-teal/15 text-brand-teal" data-id="element-105" data-mp="3sldeknkrryan">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-106" data-mp="3nnu0porzhnj8" />
                </span>
                <span className="text-sm font-semibold leading-snug text-brand-text" data-id="element-107" data-mp="1s91la9yzwimy">{item}</span>
              </li>)}
          </ul>
        </article>
        <article className="overflow-hidden rounded-[18px] bg-brand-alt shadow-sm" data-id="element-108" data-mp="1ic56xnmf12ah">
          <h2 className="bg-[#F4F5F6] px-6 py-4 text-sm font-extrabold uppercase tracking-[0.12em] text-brand-gray" data-id="element-109" data-mp="1ie9lr0lurlpj">
            NON È PER TE SE:
          </h2>
          <ul className="divide-y divide-brand-sand" data-id="element-110" data-mp="2b1vqic6tgwdz">
            {notForYouItems.map(item => <li key={item} className="flex items-start gap-3 px-6 py-4" data-id="element-111" data-mp="2fz47i9g8audn">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-black/5 text-brand-gray" data-id="element-112" data-mp="21bj4efjcsv5q">
                  <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-113" data-mp="2681779v4ijff" />
                </span>
                <span className="text-sm leading-snug text-brand-gray" data-id="element-114" data-mp="2txvk1rfg07zo">{item}</span>
              </li>)}
          </ul>
        </article>
      </Reveal>
    </section>;
}